import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const read = async (pageNumber = 20, status = '') =>
  api
    .get(`${url.stage.felContingencies}?per_page=${pageNumber}${status ? `&status=${status}` : ''}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const nextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const resumen = async (storeId, from, to) => {
  let query = `?store_id=${storeId}`
  if (from) query += `&from=${encodeURIComponent(from)}`
  if (to) query += `&to=${encodeURIComponent(to)}`

  return api
    .get(`${url.stage.felContingencies}/resumen${query}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))
}

export default {
  read,
  nextPage,
  resumen,
}
